import { Link } from 'react-router-dom';
import p5 from 'p5';
import useWindowSize from '../hooks/windowSize';
import { useEffect } from 'react';

const Home = () => {
  const { w, h } = useWindowSize();
  const sketch = (s) => {
    s.setup = () => {
      s.createCanvas(w, h);
    };

    s.draw = () => {
      // s.background(55);
      s.stroke(0);
      for (let i = 0; i < 100; i++) {
        let x = Math.random() * w;
        let y = Math.random() * h;
        let d = Math.random() * 200;
        s.circle(x, y, d);
      }
      s.noLoop();
    };
  };

  useEffect(() => {
    const myp5 = new p5(sketch, 'homeP5Container');
    return () => {};
  }, []);

  return (
    <>
      <div id="homeP5Container"></div>
      <div id="homeContent" className="vertical-container">
        <h1>HOME</h1>
        <p>Let's visualize algorithms!</p>
        <Link to="sorting">Sorting algorithms</Link>
        <Link to="arrays">Arrays</Link>
        <Link to="trees">Tree traversal</Link>
        <Link to="recursion">Recursion</Link>
      </div>
    </>
  );
};
export default Home;
